import React, { useContext } from 'react';
import { Routes, Route } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
// import AdminDashboard from "../pages/Dashboard";
import UserDashboard from "../modules/employees/UserDashboard";
import Layout from "../components/Layout";
import ProtectedRoute from "../components/ProtectedRoute";
import NotFound from '../pages/NotFound';
import ChangePassword from '../pages/ChangePassword';
import Unauthorized from '../pages/Unauthorized';
// Employee modules
import EmployeeList from "../modules/employees/EmployeeList";
import EmployeeForm from "../modules/employees/EmployeeForm";
import EmployeeProfile from "../modules/employees/EmployeeProfile";
import SelfProfile from "../modules/employees/SelfProfile";
import EmployeeImport from "../modules/employees/EmployeeImport";
import AdminDashboard from "../pages/AdminDashboard";
import PayrollDashboard from "../modules/payroll/PayrollDashboard";
import AttendanceForm from "../modules/attendance/AttendanceForm";
import MonthlySummary from "../modules/attendance/MonthlySummary";
import YearlyAttendanceCalendar from "../modules/attendance/YearlyAttendanceCalendar";
import PayrollForm from "../modules/payroll/PayrollForm";
import PayslipDownload from "../modules/payroll/PayslipDownload";
import Payroll from "../modules/payroll/Payroll";
import SettingsForm from "../modules/settings/SettingsForm";
import HolidayManagement from "../modules/holidays/HolidayManagement";
import LeaveApply from "../modules/Leave/LeaveApply";
import LeaveHistory from "../modules/Leave/LeaveHistory";
import LeaveQuota from "../modules/Leave/LeaveQuota";
import LeaveAll from "../modules/Leave/LeaveAll";
import LeaveSetup from "../modules/Leave/LeaveSetup";
import LeaveQuotaList from "../modules/Leave/LeaveQuotaList";
import LeaveQuotaUsage from "../modules/Leave/LeaveQuotaUsage";
import DepartmentsList from "../components/DepartmentsList";
import DesignationsList from "../components/DesignationsList";
import DesignationForm from "../components/DesignationForm";  
import PayrollSummary from "../modules/payroll/PayrollSummary";
import AppraisalListPage from "../modules/appraisal/pages/AppraisalListPage";
import AppraisalFormPage from "../modules/appraisal/pages/AppraisalFormPage";
import AppraisalViewPage from "../modules/appraisal/pages/AppraisalViewPage";
import EmployeeAppraisalListPage from "../modules/appraisal/pages/EmployeeAppraisalListPage";
import MyProfile from '../modules/employees/MyProfile';

const AppRoutes = () => {
  const { user } = useContext(AuthContext);
  
  return (
    <Routes>
    {/* Public Routes */}
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/change-password" element={
      <ProtectedRoute allowedRoles={['employee', 'admin', 'superadmin']}>
        <Layout>
          <ChangePassword />
        </Layout>
      </ProtectedRoute>
    } />
    
    {/* Dashboard Routes */}
    <Route path="/" element={
      <ProtectedRoute allowedRoles={['employee', 'admin', 'superadmin']}>
        {user?.role === 'employee' ? <UserDashboard /> : <AdminDashboard />}
      </ProtectedRoute>
    } />
    {/* <Route path="/dashboard" element={
      <ProtectedRoute allowedRoles={['employee', 'admin', 'superadmin']}>
        <Dashboard />
      </ProtectedRoute>
    } /> */}

    {/* Department Routes */}
    <Route path="/departments" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <DepartmentsList />
      </ProtectedRoute>
    } />

    {/* Settings */}
    <Route path="/settings" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <SettingsForm />
      </ProtectedRoute>
    } />
    <Route path="/settings/edit" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <SettingsForm />
      </ProtectedRoute>
    } />

    {/* Admin Panel (Optional UI) */}
    <Route path="/admin" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <div><h3>Admin Panel</h3></div>
      </ProtectedRoute>
    } />



    {/* Employee Management (Admin/Superadmin only) */}
    <Route path="/employees" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <EmployeeList />
      </ProtectedRoute>
    } />
    <Route path="/employees/new" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <EmployeeForm />
      </ProtectedRoute>
    } />
    <Route path="/employees/import" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <EmployeeImport />
      </ProtectedRoute>
    } />
    <Route path="/employees/:id" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <EmployeeProfile />
      </ProtectedRoute>
    } />
    <Route path="/employees/:id/edit" element={
      <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
        <EmployeeForm />
      </ProtectedRoute>
    } />

    {/* Employee Self Profile (Employee only) */}
    <Route path="/my-profile" element={
      <ProtectedRoute allowedRoles={['employee','superadmin']}>
       
          <MyProfile />
      </ProtectedRoute>
    } />




  <Route path="/holidays" element={<HolidayManagement />} />



 <Route path="/leaves" element={
  <ProtectedRoute allowedRoles={['employee', 'admin', 'superadmin']}>
    <LeaveApply />
  </ProtectedRoute>
} />

<Route path="/leaves/quota" element={
  <ProtectedRoute allowedRoles={['employee', 'admin', 'superadmin']}>
    <LeaveQuota />
  </ProtectedRoute>
} />
<Route path="/leaves/all" element={
  <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
    <LeaveAll />
  </ProtectedRoute>
} />    
<Route path="/leaves/setup" element={
  <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
    <LeaveSetup />
  </ProtectedRoute>
} />    

<Route path="/leaves/usage" element={
  <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
    <LeaveQuotaUsage />
  </ProtectedRoute>
} />   


<Route path="/designations" element={<DesignationsList />} />
<Route path="/designations/new" element={<DesignationForm />} />
<Route path="/designations/:id/edit" element={<DesignationForm />} />
<Route path="/attendance" element={<AttendanceForm />} />
<Route path="/monthly-summary" element={<MonthlySummary />} />
<Route path="/yearly-attendance" element={
  <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
    <YearlyAttendanceCalendar />
  </ProtectedRoute>
} />
<Route path="/payroll-summary" element={<PayrollSummary />} />

<Route path="/payroll" element={<Payroll />} />
<Route path="/payroll/:employeeId/:month" element={<PayrollForm />} />
<Route path="/payslip/download/:payslipId" element={<PayslipDownload />} />

<Route 
        path="/app/appraisals" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin']}>
            <AppraisalListPage />
          </ProtectedRoute>
        } 
      />

<Route 
        path="/app/appraisals/new" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin']}>
            <AppraisalFormPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/app/appraisals/:id" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin', 'employee']}>
            <AppraisalViewPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/app/appraisals/edit/:id" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin']}>
            <AppraisalFormPage />
          </ProtectedRoute>
        } 
      />

<Route 
        path="/app/appraisals/view/:id" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin', 'employee']}> 
            <AppraisalViewPage />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/app/employee-appraisals" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'manager', 'superadmin']}>
            <EmployeeAppraisalListPage />
          </ProtectedRoute>
        } 
      />




    {/* Fallback and Error Pages */}
    <Route path="/unauthorized" element={<Unauthorized />} />
    <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
